//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {ServicesHrOrg} from '@/modules/ServicesHrOrg';
import nomenclatoare from '@/store/nomenclatoare';
import {getModule} from 'vuex-module-decorators';
const storeNomenclatoare = getModule(nomenclatoare);
export default {
    name: 'NomDepartamente',
    data: ()=>{
        return{
                filter: '',
            titleDialogWindow:'',
            visibleDialogDivision:false,
                visibleDialogAddDepartament:false,
                newDivision: {
                    division_org: '',
                    division_name: ''
                }
                ,
                newDepartament: {
                    parent_id_org: 0,
                    parent_name: '',
                    departament_org: '',
                    departament_name: ''
                }
                ,
                orgTreeData: [
                    {
                        label: 'Consiliul Judetean Harghita',
                        tip_org:'societate',
                        children: []
                    }
                ]
        }
    },
    methods: {
        resetFilter() {
            this.filter = ''
            this.$refs.filter.focus()
        },
        askForRemoveDivision(params){
            const vueInst = this;
            vueInst.$q.dialog({
                title: 'Confirmare',
                message: 'Stergeti directia '+ params.label+'?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                ServicesHrOrg.deleteDivision(params.id_org).then(presponse=>{
                    if(presponse.status=='success'){
                        vueInst.getTreeOrg();
                        vueInst.$q.notify({
                            color: 'teal',
                            textColor: 'white',
                            type: 'positive',
                            message: presponse.message,
                            position: 'top',
                            timeout: 1000,
                        });
                    }
                });
            });
        },
        askForRemoveDepartament(params){
            const vueInst = this;
            vueInst.$q.dialog({
                title: 'Confirmare',
                message: 'Stergeti departamentul '+ params.label+'?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                ServicesHrOrg.deleteDepartament(params.id_org).then(presponse=>{
                    if(presponse.status=='success'){
                        vueInst.getTreeOrg();
                        vueInst.$q.notify({
                            color: 'teal',
                            textColor: 'white',
                            type: 'positive',
                            message: presponse.message,
                            position: 'top',
                            timeout: 1000,
                        });
                    }
                });
            });
        },
        openDialogAddDivision() {
            this.visibleDialogDivision = true;
            this.newDivision.division_org = 0;
            this.newDivision.division_name = '';
            this.titleDialogWindow='adaugare directie noua';
        },
        openDialogEditDivision(params){
            this.visibleDialogDivision = true;
            this.newDivision.division_org = params.id_org;
            this.newDivision.division_name = params.label;
            this.titleDialogWindow='modificare denumire directie';
        },
        openDialogAddDepartament(params) {
            //console.log('params=%o', params)
            this.newDepartament.parent_id_org = params.id_org;
            this.newDepartament.parent_name = params.label;
            this.newDepartament.departament_org = 0;
            this.newDepartament.departament_name = '';
            this.visibleDialogAddDepartament = true;
            this.titleDialogWindow='adaugare departament nou';
        },
        openDialogEditDepartament(params) {
            this.newDepartament.parent_id_org = 0;
            this.newDepartament.parent_name = '';
            this.newDepartament.departament_org = params.id_org;
            this.newDepartament.departament_name = params.label;
            this.visibleDialogAddDepartament = true;
            this.titleDialogWindow='modificare denumire departament';
        },
        saveNewDepartament() {
            const vueInst = this;
            ServicesHrOrg.updateDepartament(vueInst.newDepartament.parent_id_org,vueInst.newDepartament.departament_org, vueInst.newDepartament.departament_name).then(presponse=>{
                if(presponse.status=='success'){
                    vueInst.visibleDialogAddDivision=false;
                    vueInst.getTreeOrg();
                    vueInst.$q.notify({
                        color: 'teal',
                        textColor: 'white',
                        type: 'positive',
                        message: presponse.message,
                        position: 'top',
                        timeout: 1000,
                    });
                }
            });
        },
        saveDivision() {
            const vueInst = this;
            ServicesHrOrg.updateDivision(vueInst.newDivision.division_org, vueInst.newDivision.division_name).then(presponse=>{
              if(presponse.status=='success'){
                  vueInst.visibleDialogDivision=false;
                  vueInst.getTreeOrg();
                  vueInst.$q.notify({
                      color: 'teal',
                      textColor: 'white',
                      type: 'positive',
                      message: presponse.message,
                      position: 'top',
                      timeout: 1000,
                  });
              }
            });
        },
        getTreeOrg(){
            const vueInst = this;
            vueInst.orgTreeData[0].children=[];
            ServicesHrOrg.getNomOrganizatiiForTree().then(presponse=>{
                if(presponse.status=='success'){
                    presponse.divizii.forEach(pdivizie=>{
                        const DataDivision= {
                                            label: pdivizie.denumire,
                                            tip_org: 'division',
                                            id_org: pdivizie.appid,
                                            children:[]
                                        }
                        presponse.departamente.forEach(pdepartament=>{
                                if(pdepartament.appid_divizie==pdivizie.appid){
                                    DataDivision.children.push({
                                        label: pdepartament.departament,tip_org:'departament', id_org:1000*pdivizie.appid + 1*pdepartament.appid
                                    });
                                }
                        });
                        //console.log('push DataDivision=%o',DataDivision)
                        vueInst.orgTreeData[0].children.push(DataDivision);
                    });

                }
            });
        }
    },
    mounted(){
        const vueInst = this;
        vueInst.loadingData=true;
        storeNomenclatoare.set_currentpagetitle('Nomenclator Organizatii');
        vueInst.getTreeOrg();
    }
}
